module.exports = __webpack_public_path__ + "820f475f5c8b361904043c88bb272db9.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/server-product/images/shuzi.png
// module id = 2473
// module chunks = 31